module.exports = __webpack_public_path__ + "img/certificate-CU-Excellent.177f8184.jpg";